import React from "react"

import {L10n} from "@encoway/l10n"

import {useAppSelector} from "../app/hooks"
import {hasVisualizationChanged, selectVisualization} from "../app/visualizationSlice"
import {TranslationConstants} from "../constants/translationConstants"
import {DefaultPrimaryButton} from "./DefaultPrimaryButton/DefaultPrimaryButton"
import {useSaveConfiguration} from "../hooks/useSaveConfiguration"

export default function SaveConfigurationButton() {
    const visualization = useAppSelector(selectVisualization)
    const visualizationChanged = useAppSelector(hasVisualizationChanged)
    const saveConfiguration = useSaveConfiguration()

    return (
        <DefaultPrimaryButton
            disabled={!visualization || !visualizationChanged}
            onClick={() => saveConfiguration()}
        >
            {L10n.format(TranslationConstants.Toolbar.BUTTON_SAVE)}
        </DefaultPrimaryButton>
    )
}
